module.exports = __webpack_public_path__ + "static/media/banner2.1ec8e5cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner2.jpg
// module id = 134
// module chunks = 0